import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { WapAppResponseItem, WapAppTableData, WapAppTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: WapAppResponseItem[],
  actionsHandling: WapAppTableRowActions
): WapAppTableData[] =>
  data.map((wapAppItem: WapAppResponseItem) => {
    const { appId, createDate, settings } = wapAppItem;
    const actions = [
      {
        name: TABLE_ACTION.EDIT,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.edit({
            appId,
            appUrl: settings.appUrl,
            debugEnabled: settings.debugEnabled,
            authorizationMethod: settings.authorizationMethod,
            status: settings.status,
            externalAddress: settings.externalAddress,
            smsTemplate: settings.smsTemplate,
            process: settings.process
          });
        }
      }
    ];

    return {
      ...wapAppItem,
      id: appId,
      createDate,
      appUrl: settings.appUrl,
      status: settings.status,
      debugEnabled: settings.debugEnabled,
      actions: <ActionsColumn actions={actions} />
    };
  });
